import { Component, Input, OnInit } from "@angular/core";
import { GlobalsService } from "src/app/api/globals.service";
import { AppComponent } from "src/app/app.component";
import { DragulaService } from "ng2-dragula";
import {
  ToastController,
  NavController,
  AlertController,
  LoadingController,
  PopoverController,
} from "@ionic/angular";
import { Observable, Subject } from "rxjs";
import { BehaviorSubject } from "rxjs";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormArray,
  FormControl,
} from "@angular/forms";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import * as $ from "jquery";
import { resolve } from "dns";

import { UUID } from "angular2-uuid";
import { ActividadesService } from "src/app/services/actividades.service";
import { AuthService } from "src/app/services/auth.service";
import { windowBounds } from "epubjs/types/utils/core";
import { DatePipe } from "@angular/common";
import { ComponentDataService } from "src/app/services/component-data.service";
import { LoadingService } from "src/app/services/loading.service";
import { SearchService } from "src/app/services/search.service";
import { formatDate } from "@angular/common";
import { CursosService } from "src/app/services/cursos.service";
import { ModalLoadFilesComponent } from "../modal-load-files/modal-load-files.component";

@Component({
  selector: "app-crear-actividad",
  templateUrl: "./crear-actividad.component.html",
  styleUrls: ["./crear-actividad.component.scss"],
})
export class CrearActividadComponent implements OnInit {
  @Input() public curso: any;
  @Input() public opcion: any;
  private id: number;
  textSearch: string;

  dateA = new Date();
  fecha = {
    start: "",
    end: "",
  };
  maxYear: number;
  public reload = true;
  public id_user = 0;
  displayUserData: any;
  ismobile;
  public validP: number = 1;
  public pasos: number;
  public pasos2: number = 1;
  public nombreActividad: string;
  public habilidad: any = [];
  public ejercicios: any = [];
  public ejerciciosData: any = [];
  public tipo_ejercicios: any = [];
  public select_tipo_ejercicio: number = 0;
  ejercicioSelected: number = 0;
  ejercicioActivo: any;
  initreorder: boolean = true;
  id_pos = 1;
  items: FormArray;
  public activeOption: number = 0;
  id_option_file: number = 0;
  link_option_y: string = "";
  input_option_tipo: number = 0;
  isFechaHoraEntrega = "0";
  isActIndivi = 0;
  today = new Date().toISOString();

  id_option_fileQ: number = 0;
  input_option_tipoQ: number = 0;
  data_option_tipoQ: any = { tipo: "", value: "", object: null, b64: "" };
  input_option_Q: string = "";

  array_option_imgs: any = [];
  public opciones = [
    {
      id: 1,
      respuesta: "",
      verdadero: false,
    },
  ];
  countopcion: number = 0;
  id_user_actv: any = [];

  numCuadriculasAncho: number;
  numCuadriculasAlto: number;
  form: FormGroup;
  selectedFiles: File[] = [];
  errorMessage: string = "";
  /**************** */
  public opcionExplicacion: string = "";
  public opcionPregunta: string = "";
  public paso3Active = false;
  public opMultipleData: any = [];
  public btnLinkyoutube = false;
  /******Variables FalsoVerdadero******** */
  public fvPregunta: string = "";
  public fvFV: string = "";
  public dataVF: any = [];
  /************** */
  /******Completa el espacio******** */
  textAreacomplateEspacio: string = "";
  explAreacomplateEspacio: string = "";
  respuestasAreacomplateEspacio: any = [];
  dataAreacomplateEspacio: any = { tipo: 0, valor: "", explicacion: "" };
  /************** */
  /******Pregunta abierta******** */
  preguntaAbierta: string = "";
  input_pa_y: string = "";
  id_preguntaA_file: number = 0;
  input_preguntaA_tipo: number = 0;
  recurso_pregunta_abierta: any = {
    tipo: "",
    value: "",
    object: null,
    b64: "",
  };
  data_preguntaAbierta: any = {
    tipo: 0,
    pregunta: "",
    recurso: { tipo: "", object: null },
  };
  /************** */
  /******Clase de explicación******** */
  claseExplicacion: string = "";
  urlVideo: string = "";
  embedUrl: SafeResourceUrl | null = null;
  explicaciontemaExpl: string = "";
  id_claseExplicacion_file: number = 0;
  input_claseE_tipo: number = 0;
  input_ce_y: string = "";
  formato: string = "";
  data_ClaseExplicacion: any = {
    tipo: 0,
    explicaciontema: "",
    explicaciontemaExpl: "",
    recurso: { tipo: "", object: null },
  };
  /************** */
  /****Ordenar******** */
  AcOrdenarTipo: number = 1;
  ordenarExplicacion: string = "";
  ordenarArrayP: any = [
    { tipo: 1, input: "", recurso: { b64: null, file: null } },
  ];
  ordenarArrayS: any = [
    { tipo: 2, input: "", recurso: { b64: null, file: null } },
  ];
  data_ordenar: any = [{ tipo: 0, explicacion: "", data: null }];
  /******************* */
  /**********Memoria*********** */
  searchPersonsResult = [];
  avatar = "assets/imagenes/sistema/user1.png";

  /**********Memoria*********** */
  //data_Memoria:any = [{id:0,recurso:{file:null}}];
  //memoriaArray:any = [{recurso:{b64:null,file:null}}];
  //saveMemoria()
  data_Memoria: any = [];
  memoriaArray: any = [];
  memoriaSize: any = { x: 6, y: 6 };
  memoriaArrayObj: any = [];
  memObjItems: any = [];
  memObjFile: any = [];
  itemEditMem: any;
  /**********Fin Memoria******* */
  /******Sopa de letras******** */
  data_SopaLetras: any = { tipo: 0, valor: null };
  puzzleMin: any = { y: 5, x: 5 };
  puzzleMax: number = 10;
  puzzleObj: any = [];
  flagOpen: string = "";
  word: string = "";
  flagClosed: string = "";
  codigos: any = [];
  flagOpenTemp: string = "";
  palabras: any = [];
  palabraInput: string = "";
  /************** */
  actividadesEjercicios: any = [];
  actividadesHabilidades: any = [];
  addFileExplication: number = 0;
  urlImage: any;
  typeFile: number = 0;
  fileImage: any;
  maxLengthTextArea: number = 5000;
  resetALL() {
    this.form.reset();

    this.selectedFiles = [];
    this.urlVideo = "";
    this.embedUrl = null;
    this.dragulaService.destroy("bag");
    this.dragulaService.destroy("bag2");
    this.dragulaService.destroy("bag3");
    this.subscription.unsubscribe();
    this.actividadesEjercicios = [];
    this.actividadesHabilidades = [];
    this.palabraInput = "";
    this.data_SopaLetras = { tipo: 0, valor: null };
    this.puzzleMin = { y: 5, x: 5 };
    this.puzzleMax = 10;
    this.puzzleObj = [];
    this.flagOpen = "";
    this.word = "";
    this.flagClosed = "";
    this.codigos = [];
    this.flagOpenTemp = "";
    this.palabras = [];
    this.palabraInput = "";
    //saveMemoria()
    this.data_Memoria = [];
    this.memoriaArray = [];
    this.memoriaSize = { x: 6, y: 6 };
    this.memoriaArrayObj = [];
    this.memObjFile = [];
    this.memObjItems = [];
    this.itemEditMem = null;
    /****Ordenar******** */
    this.AcOrdenarTipo = 1;
    this.ordenarExplicacion = "";
    this.ordenarArrayP = [
      { tipo: 1, input: "", recurso: { b64: null, file: null } },
    ];
    this.ordenarArrayS = [
      { tipo: 2, input: "", recurso: { b64: null, file: null } },
    ];
    this.data_ordenar = [{ tipo: 0, explicacion: "", data: null }];
    /******Clase de explicación******** */
    this.claseExplicacion = "";
    this.id_claseExplicacion_file = 0;
    this.input_claseE_tipo = 0;
    this.input_ce_y = "";
    this.formato = "";
    this.data_ClaseExplicacion = {
      tipo: 0,
      explicaciontema: "",
      explicaciontemaExp: "",
      recurso: { tipo: "", object: null },
    };
    /******Pregunta abierta******** */
    this.preguntaAbierta = "";
    this.input_pa_y = "";
    this.id_preguntaA_file = 0;
    this.input_preguntaA_tipo = 0;
    this.recurso_pregunta_abierta = {
      tipo: "",
      value: "",
      object: null,
      b64: "",
    };
    this.data_preguntaAbierta = {
      tipo: 0,
      pregunta: "",
      recurso: { tipo: "", object: null },
    };
    /******Completa el espacio******** */
    this.textAreacomplateEspacio = "";
    this.explAreacomplateEspacio = "";
    this.respuestasAreacomplateEspacio = [];
    this.dataAreacomplateEspacio = { tipo: 0, valor: "", explicacion: "" };
    /******Variables FalsoVerdadero******** */
    this.fvPregunta = "";
    this.fvFV = "";
    this.dataVF = [];
    this.opcionExplicacion = "";
    this.opcionPregunta = "";
    this.paso3Active = false;
    this.opMultipleData = [];
    this.btnLinkyoutube = false;
    /**************** */
    this.opcionExplicacion = "";
    this.opcionPregunta = "";
    this.paso3Active = false;
    this.opMultipleData = [];
    this.btnLinkyoutube = false;
    /**************** */
    this.habilidad = [];
    this.ejercicios = [];
    this.ejerciciosData = [];
    this.tipo_ejercicios = [];
    this.select_tipo_ejercicio = 0;
    this.ejercicioSelected = 0;
    this.ejercicioActivo = null;
    this.initreorder = true;
  }
  private auth_key: string = "";
  public stringVar = new BehaviorSubject({ valid: false });
  public stringVar$ = this.stringVar.asObservable();
  constructor(
    public globalsService: GlobalsService,
    private dragulaService: DragulaService,
    private toastController: ToastController,
    public formBuilder: FormBuilder,
    private sanitizer: DomSanitizer,
    public alertController: AlertController,
    private authService: AuthService,
    public actividadesService: ActividadesService,
    private datePipe: DatePipe,
    public dataService: ComponentDataService,
    private loadingServices: LoadingService,
    private searchService: SearchService,
    public navCtrl: NavController,
    public cursosService: CursosService,
    private fb: FormBuilder,
    public loadingCtrl: LoadingController,
    private popoverCtrl: PopoverController
  ) {
    this.form = this.fb.group({
      images: [null, [Validators.required, this.fileValidator.bind(this)]],
    });
    this.isFechaHoraEntrega = "0";

    //this.fecha = this.datePipe.transform(this.dateA, 'yyyy-MM-dd');
    this.fecha.start = this.datePipe.transform(this.dateA, "yyyy-MM-dd H:mm");
    this.fecha.end = this.datePipe.transform(this.dateA, "yyyy-MM-dd H:mm");
    this.maxYear = parseInt(this.datePipe.transform(this.dateA, "yyyy")) + 1;
    this.id = this.displayUserData?.id;

    //
    let auth_key = "";
    let init = 0;
    this.authService.userData$.subscribe((res: any) => {
      this.displayUserData = res;
      auth_key = this.displayUserData?.auth_key;
      console.log("auth_key: ", auth_key);
      this.id_user = this.displayUserData?.id;
      if (auth_key && init == 0) {
        init++;
        this.auth_key = auth_key;
        this.actividadesService.getAll(auth_key).subscribe((response) => {
          let body: any = response;
          //btnHabilidades
          if (body.auth_key) {
            if (
              body.data.tipo != undefined &&
              body.data.habilidades != undefined
            ) {
              let actividadesEjercicios = body.data.tipo;
              let actividadesHabilidades = body.data.habilidades;
              actividadesEjercicios.forEach((element, index, array) => {
                let tempT = {
                  id: element.posicion,
                  titulo: element.titulo,
                  seleccionado: element.seleccionado == 0 ? false : true,
                };

                this.actividadesEjercicios.push(tempT);
              });
              actividadesHabilidades.forEach((element, index, array) => {
                let tempH = {
                  index: element.id,
                  id: element.posicion,
                  titulo: element.titulo,
                  seleccionado: element.seleccionado == 0 ? false : true,
                  valor: element.valor,
                };
                this.actividadesHabilidades.push(tempH);
                if (index == array.length - 1) {
                }
              });
            }
          } else {
            /*this.logoutAction();
            this.toastService.presentToast( "Debe iniciar sesión" );*/
          }
        });
      }
    });
    this.ismobile = globalsService.isMobile;

    if (this.initreorder) {
      this.initreorder = false;
      /************** */
      this.dragulaService.drag("bag").subscribe(({ name, el, source }) => {
        //el.setAttribute('color', 'white');
      });

      this.dragulaService.removeModel("bag").subscribe(({ item }) => {
        this.toastController
          .create({
            message: "Pregunta removida: ",
            duration: 2000,
          })
          .then((toast) => toast.present());
      });

      this.dragulaService.dropModel("bag").subscribe(({ item }) => {});

      /************** */
      this.dragulaService.drag("bag2").subscribe(({ name, el, source }) => {
        //el.setAttribute('color', 'white');
      });

      this.dragulaService.removeModel("bag2").subscribe(({ item }) => {
        this.toastController
          .create({
            message: "Pregunta removida: ",
            duration: 2000,
          })
          .then((toast) => toast.present());
      });

      this.dragulaService.dropModel("bag2").subscribe(({ item }) => {});
      /************** */
      this.dragulaService.drag("bag3").subscribe(({ name, el, source }) => {
        //el.setAttribute('color', 'white');
      });

      this.dragulaService.removeModel("bag3").subscribe(({ item }) => {
        this.toastController
          .create({
            message: "Pregunta removida: ",
            duration: 2000,
          })
          .then((toast) => toast.present());
      });

      this.dragulaService.dropModel("bag3").subscribe(({ item }) => {});
    }
    /*this.dragulaService.createGroup('bagDelete', {
      removeOnSpill: true
    });/******* */
  }
  ngOnInit() {
    this.actividadesEjercicios = [];
    this.actividadesHabilidades = [];
    this.nombreActividad = "";
    this.pasos = this.validP;
    this.habilidad = this.btnHabilidades();
    this.tipo_ejercicios = this.btnTipoEjercicios();
    if (this.nombreActividad == "") {
      this.validP = 1;
      this.pasos = this.validP;
    }
    const form = new FormGroup({
      password: new FormControl("", Validators.minLength(2)),
      passwordConfirm: new FormControl("", Validators.minLength(2)),
    });

    this.initMatriz();
    this.memoriaInit();
    this.getStudents();
    const now = new Date();
    const dateTime = formatDate(now, "yyyy-MM-ddTHH:mm", "en-US");

    this.fecha.start = dateTime;
    this.fecha.end = dateTime;

    console.log("dataService: ", this.dataService.getData());
  }
  /********Core Ordenar************* */
  ordenarTipo(tipo) {
    this.AcOrdenarTipo = tipo;
    if (this.AcOrdenarTipo == 1) {
      this.validarOrdenarP();
    } else if (this.AcOrdenarTipo == 2) {
      this.paso3Active = false;
    }
  }

  onDataOpcionMultiple(event) {
    //console.log("🚀 ~ CrearActividadComponent ~ onDataOpcionMultiple ~ event:", event)
    this.opMultipleData = { ...event.data, id_tipo: 1 };
    this.paso3Active = event.valid;
  }
  addSecuencia() {
    this.ordenarArrayS.push({
      tipo: 2,
      input: "",
      recurso: { b64: null, file: null },
    });
    this.validarOrdenarS();
  }
  ordenarVerificar() {}
  addPareja() {
    //ordenarArrayP:any = [{input:'',recurso:{b64:null,file:null}}];
    this.ordenarArrayP.push({
      tipo: 1,
      input: "",
      recurso: { b64: null, file: null },
    });
    this.validarOrdenarP();
  }

  addFileOrdenar(id) {
    let inputText: any = document.getElementById(id) as HTMLInputElement;
    inputText.click();
  }
  addFileOrdenarEv(event: EventTarget) {
    let evento: any = event;
    let idele = evento.target.id;
    let idbox = idele + "-box";
    let data = evento.target.dataset.pos;
    let eventObj: any = event;
    let target: HTMLInputElement = eventObj.target as HTMLInputElement;
    let files = target.files;
    let file: File = target.files[0];
    let _this = this;
    if (FileReader && file && files.length) {
      var fr = new FileReader();
      fr.onload = function () {
        //{tipo:'',value:'',object:null,b64:''};
        let b64 = fr.result;
        _this.ordenarArrayP[data].recurso.file = file;
        _this.ordenarArrayP[data].recurso.b64 = b64;
        //console.log('_this.ordenarArrayP',_this.ordenarArrayP);
        _this.validarOrdenarP();
      };
      fr.readAsDataURL(file);
      //this.closeFileAdd();
    }
  }
  addFileOrdenarSec(id) {
    let inputText: any = document.getElementById(id) as HTMLInputElement;
    inputText.click();
  }
  addFileOrdenarSecEv(event: EventTarget) {
    let evento: any = event;
    let idele = evento.target.id;
    let idbox = idele + "-box";
    let data = evento.target.dataset.pos;
    let eventObj: any = event;
    let target: HTMLInputElement = eventObj.target as HTMLInputElement;
    let files = target.files;
    let file: File = target.files[0];
    let _this = this;
    if (FileReader && file && files.length) {
      var fr = new FileReader();
      fr.onload = function () {
        //{tipo:'',value:'',object:null,b64:''};
        let b64 = fr.result;
        _this.ordenarArrayS[data].recurso.file = file;
        _this.ordenarArrayS[data].recurso.b64 = b64;
        //console.log('_this.ordenarArrayP',_this.ordenarArrayP);
        _this.validarOrdenarS();
      };
      fr.readAsDataURL(file);
      //this.closeFileAdd();
    }
  }
  deleteOrdenar(i) {
    if (this.ordenarArrayP.length > 1) {
      this.ordenarArrayP.splice(i, 1);
      this.validarOrdenarP();
    } else {
      this.deleteAlert();
    }
  }
  validarOrdenarS() {
    let valid = true;
    if (this.ordenarArrayS.length < 2) {
      valid = false;
      this.paso3Active = valid;
      return;
    }
    this.ordenarArrayS.forEach((element, index) => {
      let input: any = document.getElementById(
        "ordenar-sec" + index
      ) as HTMLInputElement;
      if (element.tipo === 1 && element.recurso.file == null) {
        valid = false;
      }
      if (input == null) {
        valid = false;
      } else if (!this.validInput(input)) {
        valid = false;
      }
      this.paso3Active = valid;
    });
  }
  deleteOrdenarSec(i) {
    if (this.ordenarArrayS.length > 1) {
      this.ordenarArrayS.splice(i, 1);
      this.validarOrdenarS();
    } else {
      this.deleteAlertSec();
    }
  }
  async deleteAlertSec() {
    const alert = await this.alertController.create({
      cssClass: "my-custom-class",
      header: "Información",
      subHeader: "",
      message: "No se puede eliminar este elemento",
      buttons: ["Aceptar"],
    });

    await alert.present();
  }

  //const alert = await this.alertController.create({
  async saveAllMsg(message) {
    const alert = await this.alertController.create({
      cssClass: "my-custom-class",
      header: "Información",
      subHeader: "",
      message: message,
      buttons: [
        {
          text: "Aceptar",
          handler: () => {},
        },
      ],
    });
    await alert.present();
    await alert.onDidDismiss().then((data) => {
      if (this.reload) {
        //window.location.reload();
        this.dataService.setData([
          {
            curso: this.curso.id,
            data: [{ crearCurso: true, opcion: 1 }],
          },
        ]);
      } else {
        this.reload = true;
      }
    });
  }
  async deleteAlert() {
    const alert = await this.alertController.create({
      cssClass: "my-custom-class",
      header: "Información",
      subHeader: "",
      message: "No se puede eliminar este elemento",
      buttons: ["Aceptar"],
    });

    await alert.present();
  }
  validarOrdenarPBK() {
    let valid = true;
    if (this.ordenarArrayP.length < 2) {
      valid = false;
      this.paso3Active = valid;
      return;
    }
    this.ordenarArrayP.forEach((element, index) => {
      let input: any = document.getElementById(
        "pareja-input-" + index
      ) as HTMLInputElement;

      if (element.recurso.file == null) {
        valid = false;
      }
      if (input == null) {
        valid = false;
      } else if (!this.validInput(input)) {
        valid = false;
      }
      if (index == this.ordenarArrayP.length - 1) {
        //
        let input2: any = document.getElementById(
          "ordenarExplicacion"
        ) as HTMLInputElement;
        if (!this.validInput(input2)) {
          valid = false;
          this.paso3Active = valid;
        } else {
          this.paso3Active = valid;
        }
      }
    });
  }
  validarOrdenarP() {
    let valid = true;
    if (this.ordenarArrayP.length < 2) {
      valid = false;
      this.paso3Active = valid;
      return;
    }
    this.ordenarArrayP.forEach((element, index) => {
      let input: any = document.getElementById(
        "pareja-input-" + index
      ) as HTMLInputElement;

      if (element.recurso.file == null) {
        valid = false;
      }
      if (input == null) {
        valid = false;
      } else if (!this.validInput(input)) {
        valid = false;
      }
      this.paso3Active = valid;
      // if (index == this.ordenarArrayP.length - 1) {
      //   //
      //   let input2: any = document.getElementById(
      //     "ordenarExplicacion"
      //   ) as HTMLInputElement;
      //   if (!this.validInput(input2)) {
      //     valid = false;
      //     this.paso3Active = valid;
      //   } else {
      //     this.paso3Active = valid;
      //   }
      // }
    });
  }
  validarOrdenar() {
    let valid = true;
    if (this.ordenarArrayP.length < 2) {
      valid = false;
      this.paso3Active = valid;
      return;
    }
    this.ordenarArrayP.forEach((element, index) => {
      let input: any = document.getElementById(
        "pareja-input-" + index
      ) as HTMLInputElement;

      if (element.recurso.file == null) {
        valid = false;
      }
      if (input == null) {
        valid = false;
      } else if (!this.validInput(input)) {
        valid = false;
      }
      if (index == this.ordenarArrayP.length - 1) {
        //
        let input2: any = document.getElementById(
          "ordenarExplicacion"
        ) as HTMLInputElement;
        if (!this.validInput(input2)) {
          valid = false;
          this.paso3Active = valid;
        } else {
          this.paso3Active = valid;
        }
      }
    });
  }
  resetOrdenar() {
    this.ordenarArrayP = [
      { tipo: 1, input: "", recurso: { b64: null, file: null } },
    ];
    this.ordenarArrayS = [
      { tipo: 2, input: "", recurso: { b64: null, file: null } },
    ];
  }
  /********Fin Ordenar************ */

  /********Core Memoria************* */

  // Luego, en tu método memoriaInit(), calcula numCuadriculasAncho y numCuadriculasAlto en base a numParejas
  memoriaInit() {
    // Calcula el total de cuadrículas (el doble del número de imágenes)
    let totalCuadriculas = this.selectedFiles.length * 2;
    // Calcula el número de cuadrículas de ancho y alto (divisores más cercanos al cuadrado del total de cuadrículas)
    let numCuadriculasAncho = Math.ceil(Math.sqrt(totalCuadriculas));
    let numCuadriculasAlto = Math.ceil(totalCuadriculas / numCuadriculasAncho);
    return new Promise((resolve) => {
      this.memoriaArrayObj = [];
      this.memObjFile = [];
      this.memoriaArray = [];
      let currentCuadricula = 0;
      for (let i = 0; i < numCuadriculasAlto; i++) {
        let idY = this.pad(i, 2);
        this.memoriaArrayObj.push({ y: idY, x: [] });
        for (let j = 0; j < numCuadriculasAncho; j++) {
          if (currentCuadricula < totalCuadriculas) {
            let idX = this.pad(j, 2);
            this.memObjItems.push("y" + idY + "_x" + idX);
            this.memoriaArrayObj[i].x.push({
              id: "y" + idY + "_x" + idX,
              code: "",
              recursos: { b64: null, file: null },
            });
            currentCuadricula++;
          }
        }
      }
      this.addFileMemoriaEv();
      resolve(true);
    });
  }

  addPuzzleMem() {
    let flag = this.memoriaArray.length - 1;
    if (this.memObjItems.length == 0) {
      return;
    }
    //this.memoriaArrayObj[i].x.push({id:('y'+idY+'_x'+idX),recursos:{b64:null,file:null}});
    let b64 = this.memoriaArray[flag].recurso.b64;
    let file = this.memoriaArray[flag].recurso.file;
    let name = this.memoriaArray[flag].recurso.file.name;
    let code = "";
    let item = "";
    let item2 = "";
    code = this.generateUUID();
    let m = new Promise((resolve) => {
      let i = Math.floor(Math.random() * this.memObjItems.length + 0);
      item = this.memObjItems[i];
      this.memoriaArrayObj.forEach((element, index, array) => {
        element.x.forEach((elementX) => {
          if (elementX.id == item) {
            this.memObjItems.splice(i, 1);
            elementX.recursos.b64 = b64;
            elementX.recursos.file = file;
            elementX.code = code;
          }
          if (index == array.length - 1) {
            resolve(true);
          }
        });
      });
    });
    m.then((insert) => {
      console.log("insert: ", insert);
      let j = Math.floor(Math.random() * this.memObjItems.length + 0);
      //this.memoriaArrayObj[i].x.push({id:('y'+idY+'_x'+idX),recursos:{b64:null,file:null}});
      item2 = this.memObjItems[j];
      console.log(" this.memoriaArrayObj: ", this.memoriaArrayObj);
      this.memoriaArrayObj.forEach((element, index, array) => {
        element.x.forEach((elementX) => {
          if (elementX.id == item2) {
            elementX.recursos.b64 = b64;
            elementX.recursos.file = file;
            elementX.code = code;
            elementX.name = file.name;
            this.memObjFile.push({ code: code, b64: b64, name: name });
            this.memObjItems.splice(j, 1);
            console.log("this.memObjItems: ", this.memObjItems);
          }
          if (index == array.length - 1) {
            console.log("memoriaArrayObj: ", this.memoriaArrayObj);
            this.validarMemoria();
          }
        });
      });
    });
    //$('#'+item+'-img').attr('src',b64);
  }
  resetMemoria() {
    this.data_Memoria = [];
    this.memoriaArray = [];
    this.memoriaArrayObj = [];
    this.memObjFile = [];
    this.memoriaSize = [{ x: 6, y: 6 }];
  }
  addMemImg() {
    let inputText: any = document.getElementById(
      "img-memoria-input"
    ) as HTMLInputElement;
    inputText.click();
  }
  editFileMemoria(item) {
    this.itemEditMem = item;
    let inputText: any = document.getElementById(
      "img-memoria-input-edit"
    ) as HTMLInputElement;
    inputText.click();
  }
  deleteItem(item) {
    this.memObjFile = this.memObjFile.filter(
      (element) => element.code != item.code
    );
    this.memoriaArrayObj = this.memoriaArrayObj.map((element) => {
      element.x = element.x.filter((elementX) => elementX.code != item.code);
      return element;
    });
    this.selectedFiles = this.selectedFiles.filter(
      (element) => element.name != item.name
    );
  }
  editFileMemoriaEv(event: EventTarget) {
    let code = this.itemEditMem.code;

    let evento: any = event;
    let idele = evento.target.id;
    let idbox = idele + "-box";
    let data = evento.target.dataset.pos;
    let eventObj: any = event;
    let target: HTMLInputElement = eventObj.target as HTMLInputElement;
    let files = target.files;
    let file: File = target.files[0];
    let _this = this;
    if (FileReader && file && files.length) {
      var fr = new FileReader();
      fr.onload = function () {
        let b64 = fr.result;
        //this.memoriaArrayObj[i].x.push({id:('y'+idY+'_x'+idX),code:'',recursos:{b64:null,file:null}});
        _this.memoriaArrayObj.forEach((element) => {
          element.x.forEach((elementX) => {
            if (elementX.code == code) {
              elementX.recursos.file = file;
              elementX.recursos.b64 = b64;
              _this.itemEditMem.b64 = b64;
            }
          });
        });

        //_this.addPuzzleMem();
        //_this.validarMemoria();
      };
      fr.readAsDataURL(file);
      //this.closeFileAdd();
    }
  }
  addFileMemoriaEv() {
    this.selectedFiles.forEach((file) => {
      let _this = this;
      if (FileReader && file) {
        var fr = new FileReader();
        fr.onload = function () {
          //{tipo:'',value:'',object:null,b64:''};
          let b64 = fr.result;
          _this.memoriaArray.push({
            recurso: { b64: b64, file: file, name: file.name },
          });
          _this.addPuzzleMem();
        };
        fr.readAsDataURL(file);
        //this.closeFileAdd();
      }
    });
  }
  validarMemoria() {
    console.log("memObjItems: ", this.memObjItems.length);
    if (this.memObjItems.length == 0) {
      this.paso3Active = true;
    } else {
      this.paso3Active = false;
    }
  }

  /********Fin Core Memoria************* */

  /********Core Sopa de Letras***** */
  initMatriz() {
    return new Promise((resolve) => {
      for (let i = 0; i < this.puzzleMin.y; i++) {
        let idY = this.pad(i, 2);
        this.puzzleObj.push({ idY: idY, idX: [] });
        for (let j = 0; j < this.puzzleMin.x; j++) {
          let idX = this.pad(j, 2);
          this.puzzleObj[i].idX.push(idX);
        }
        if (i == this.puzzleMin.y - 1) {
          resolve(true);
        }
      }
    });
  }

  posiciones: any = [
    "horizontal",
    "horizontalR",
    "vertical",
    "verticalR",
    "diagonalD",
    "diagonalDR",
    "diagonalU",
    "diagonalUR",
  ];

  rezise = false;
  resizePuzle(texto = null) {
    let add = 0;
    let tamano = 0;
    let tamano1 = 0;
    tamano = this.palabras.length;
    if (texto) {
      tamano1 = texto.length;
    } else {
      this.palabras.forEach((element) => {
        if (element.palabra.length > tamano) {
          tamano = element.palabra.length;
        }
      });
    }
    if (tamano1 > tamano) {
      tamano = tamano1;
    }
    if (tamano < this.puzzleMax) {
      tamano++;
    }

    if (this.puzzleMin.y > tamano) {
      tamano = this.puzzleMin.y;
    }

    this.puzzleMin.y = tamano;
    this.puzzleMin.x = tamano;
    if (this.puzzleMin.y > this.puzzleMax) {
      this.puzzleMin.y = this.puzzleMax;
      this.puzzleMin.x = this.puzzleMax;
    }
    this.puzzleObj = [];
    let palabras: any = this.palabras;
    this.palabras = [];
    if (texto) palabras.push({ palabra: texto });

    let m = new Promise((resolve) => {
      console.log("aumentando la matriz...");
      this.initMatriz().then((insert) => {
        setTimeout(() => {
          resolve(true);
        }, 200);
      });
    });
    //this.palabras.push({palabra:texto,codigo:codigo,tipo:this.posiciones[1]});
    m.then((insert) => {
      this.palabraInput = "";
      console.log("matriz aumentada...");
      this.rezise = true;
      palabras.forEach((element) => {
        //console.log('palabras: ',palabras);

        setTimeout(() => {
          this.addText(element.palabra).then((value) => {
            console.log(`promise result: ${value}`);
            //Storage
            this.rezise = false;
          });
        }, 10);
      });
    });
  }
  puzzleReorder() {
    if (this.palabras.length >= 0) {
      this.resizePuzle();
    }
  }

  eventHandlerPuzzle(keyCode) {
    if (keyCode == 13) {
      this.addText();
    }
  }
  puzzleIntentos = 0;
  lastPosition: number = -1;

  addText(resizeText = null) {
    //let texto = $('#text-puzzle').val();

    return new Promise((resolve) => {
      this.puzzleIntentos++;
      if (this.puzzleIntentos > 1500) {
        alert(
          'Se han sobrepasado los intentos de insertar la palabra: "' +
            this.palabraInput +
            '"' +
            ""
        );
        this.puzzleIntentos = 0;
        resolve(false);
        return;
      }
      console.log("resizeText: ", resizeText);

      let texto = "";
      if (resizeText == null) {
        texto = this.palabraInput;
      } else {
        texto = resizeText;
      }
      if (resizeText == null) {
        texto = this.palabraInput;
        if (!this.puzzleVerificarLimite(texto) && resizeText == null) {
          this.palabraInput = "";
          return;
        }

        let maxLen1 = this.palabras.length;
        let maxLen2 = this.puzzleMin.y;
        let maxLen = maxLen2;
        if (maxLen1 > maxLen2) {
          maxLen = maxLen1;
        }

        if (
          (maxLen >= this.puzzleMin.y &&
            this.puzzleMin.y < this.puzzleMax &&
            texto.length >= maxLen) ||
          (maxLen1 >= this.puzzleMin.y && this.puzzleMin.y < this.puzzleMax)
        ) {
          console.log(
            "resizeText - Resize Puzle 1... resizeText: ",
            resizeText
          );
          this.resizePuzle(texto);
          return;
        }
      }
      let max = this.posiciones.length;
      let min = 0;
      let r = Math.floor(Math.random() * (max - 0 + 1) + min);

      console.log("random: " + r);
      //this._horizontal(texto);

      if (this.lastPosition >= -1) {
        r = Math.floor(Math.random() * (2 - 1 + 1) + min);
      } else {
      }
      r = Math.floor(Math.random() * (5 - 1 + 1) + min);
      console.log("Random result r: ", r);
      setTimeout(() => {
        if (r == 0)
          this._horizontal(texto).then((value) => {
            this.lastPosition = r;
            console.log(`_horizontal Selected: ${value}`);
            resolve(value);
          }); /** */
        if (r == 1)
          this._horizontalR(texto).then((value) => {
            this.lastPosition = r;
            console.log(`_horizontalR Selected: ${value}`);
            resolve(value);
          }); /** */
        if (r == 2)
          this._vertical(texto).then((value) => {
            this.lastPosition = r;
            console.log(`_vertical Selected: ${value}`);
            resolve(value);
          });
        if (r == 3)
          this._verticalR(texto).then((value) => {
            this.lastPosition = r;
            console.log(`_verticalR Selected: ${value}`);
            resolve(value);
          });
        if (r == 4)
          this._diagonalD(texto).then((value) => {
            this.lastPosition = r;
            console.log(`_diagonalD Selected: ${value}`);
            resolve(value);
          });
      }, 50);
    });
  }

  ngAfterViewInit() {
    let _this = this;
    $(document).ready(function () {});
  }
  mousedown(id) {
    let _this = $("#" + id);
    this.flagOpen = "";
    let flagClosed = "";
    this.word = "";
    this.flagOpenTemp = "";
    this.flagOpen = $(_this).attr("id");
    if (this.word == "") this.word = $.trim($(_this).text());
    this.flagOpenTemp = this.flagOpen;
    console.log("Open: ", this.flagOpen);
    $(".p-caja").removeClass("selected");
  }
  mouseup(id) {
    if (this.flagOpen != "") {
      this.flagClosed = "";
      this.flagClosed = $("#" + id).attr("id");
      console.log("close: ", this.flagClosed);
      let open = this.flagOpen.split("_");
      let openR = parseInt(open[0].replace("r", ""));
      let openC = parseInt(open[1].replace("c", ""));

      let close = this.flagClosed.split("_");
      let closeR = parseInt(close[0].replace("r", ""));
      let closeC = parseInt(close[1].replace("c", ""));
      console.log("Word: ", this.word);
      console.log("codigos: ", this.codigos);
      this.codigos = [];
      $(".p-caja").removeClass("selected");
      this.flagOpen = "";
      this.flagOpenTemp = "";
      this.flagClosed = "";
      if (this.word != "") {
        this.word = "";
      }
    }
  }
  mouseover(id) {
    if (this.flagOpen != "") {
      if (!this.diagonalDU("#" + id)) {
        if (!this.diagonalUD("#" + id)) {
          if (!this.horizontalNormal("#" + id)) {
            this.verticarNormal("#" + id);
          }
        }
      }
    }
  }
  diagonalDU(element) {
    let str = $(element).attr("id");
    var res = str.split("_");
    let open = this.flagOpenTemp.split("_");
    let openR = parseInt(open[0].replace("r", ""));
    let openC = parseInt(open[1].replace("c", ""));
    let r = parseInt(res[0].replace("r", ""));
    let c = parseInt(res[1].replace("c", ""));
    let r1 = r - openR;
    let c1 = openC + r1;
    //console.log('r1: ' + r1 + ' / c1: ' + c1);
    this.word = "";
    if (c1 == c) {
      if (r1 < 0) {
        console.log("Diagonal inversa");
        $(".p-caja").removeClass("selected");
        $("input").removeClass("selected");
        for (let i = 0; i <= r1 * -1; i++) {
          let clase =
            "#r" + this.pad(openR - i, 2) + "_c" + this.pad(openC - i, 2);
          //console.log(clase);
          $(clase).addClass("selected");
          $(clase + "i").addClass("selected");
          this.word += $.trim($(clase).text());
        }
      } else {
        //console.log('Diagonal normal');
        $(".p-caja").removeClass("selected");
        $("input").removeClass("selected");
        for (let i = 0; i <= r1; i++) {
          let clase =
            "#r" + this.pad(openR + i, 2) + "_c" + this.pad(openC + i, 2);
          $(clase).addClass("selected");
          $(clase + "i").addClass("selected");
          this.word += $.trim($(clase).text());
        }
      }
      return true;
    } else {
      return false;
    }
  }
  diagonalUD(element) {
    let str = $(element).attr("id");
    var res = str.split("_");
    let open = this.flagOpenTemp.split("_");
    let openR = parseInt(open[0].replace("r", ""));
    let openC = parseInt(open[1].replace("c", ""));
    let r = parseInt(res[0].replace("r", ""));
    let c = parseInt(res[1].replace("c", ""));
    let c1 = c - openC;
    let r1 = openR - r;
    if (c1 == r1) {
      if (c1 < 0) {
        this.word = "";
        $(".p-caja").removeClass("selected");
        $("input").removeClass("selected");
        for (let i = 0; i <= r1 * -1; i++) {
          let clase =
            "#r" + this.pad(openR + i, 2) + "_c" + this.pad(openC - i, 2);
          $(clase).addClass("selected");
          $(clase + "i").addClass("selected");
          this.word += $.trim($(clase).text());
        }
      } else {
        this.word = "";
        $(".p-caja").removeClass("selected");
        $("input").removeClass("selected");
        for (let i = 0; i <= r1; i++) {
          let clase =
            "#r" + this.pad(openR - i, 2) + "_c" + this.pad(openC + i, 2);
          $(clase).addClass("selected");
          $(clase + "i").addClass("selected");
          this.word += $.trim($(clase).text());
        }
      }
      return true;
    } else {
      return false;
    }
  }
  horizontalNormal(element) {
    let str = $(element).attr("id");
    let res = str.split("_");
    let open = this.flagOpenTemp.split("_");
    let openR = parseInt(open[0].replace("r", ""));
    let openC = parseInt(open[1].replace("c", ""));
    let r = parseInt(res[0].replace("r", ""));
    let c = parseInt(res[1].replace("c", ""));
    let r1 = r - openR;
    let c1 = c;
    if (openR == r) {
      if (openC < c) {
        console.log("horizontalNormal");
        this.word = "";
        this.codigos = [];
        $(".p-caja").removeClass("selected");
        $("input").removeClass("selected");
        for (let i = 0; i <= c - openC; i++) {
          let clase = "#r" + this.pad(openR, 2) + "_c" + this.pad(openC + i, 2);
          $(clase).addClass("selected");
          $(clase + "i").addClass("selected");
          this.codigos.push(clase);
          this.word += $.trim($(clase).text());
        }
      } else {
        console.log("horizontal reversa");
        $(".p-caja").removeClass("selected");
        $("input").removeClass("selected");
        for (let i = openC; i >= c1; i--) {
          let clase = "#r" + this.pad(openR, 2) + "_c" + this.pad(i, 2);
          $(clase).addClass("selected");
          $(clase + "i").addClass("selected");
          this.word += $.trim($(clase).text());
        }
      }
      return true;
    }
    return false;
  }
  verticarNormal(element) {
    let str = $(element).attr("id");
    var res = str.split("_");
    let open = this.flagOpenTemp.split("_");
    let openR = parseInt(open[0].replace("r", ""));
    let openC = parseInt(open[1].replace("c", ""));
    let r = parseInt(res[0].replace("r", ""));
    let c = parseInt(res[1].replace("c", ""));
    //console.log( 'openR: ' + (openR) + ' | openC: ' + (openC) );
    let r1 = r - openR;
    let c1 = c;
    console.log("r: " + r + " / c: " + c1);
    if (openC == c) {
      if (openR < r) {
        console.log("Vertical normal");
        this.word = "";
        $(".p-caja").removeClass("selected");
        $("input").removeClass("selected");
        for (let i = 0; i <= r - openR; i++) {
          let clase = "#r" + this.pad(openR + i, 2) + "_c" + this.pad(openC, 2);
          $(clase).addClass("selected");
          $(clase + "i").addClass("selected");
          this.word += $.trim($(clase).text());
          console.log("Clase v: ", i);
        }
      } else {
        this.word = "";
        $(".p-caja").removeClass("selected");
        $("input").removeClass("selected");
        console.log("Vertical reverso");
        $(".p-caja").removeClass("selected");
        for (let i = openR; i >= r; i--) {
          let clase = "#r" + this.pad(i, 2) + "_c" + this.pad(openC, 2);
          $(clase).addClass("selected");
          $(clase + "i").addClass("selected");
          this.word += $.trim($(clase).text());
        }
      }
    }
  }
  puzzleVerificarLimite(texto) {
    let retorno: boolean = true;
    let input: any = document.getElementById("text-puzzle") as HTMLInputElement;
    if (!this.validInput(input, false)) {
      alert(
        "¡Formato invalido! El campo debe contener entre 3 y 10 caracteres. Solo se permiten letras, incluidas mayúsculas, minúsculas y letras con acentos (como á, é, í, ó, ú, ñ, ü). No se permiten números, espacios ni caracteres especiales."
      );
      return false;
    }
    let max = this.puzzleMin.y;
    if (this.palabras.length >= this.puzzleMax) {
      alert("Ha llegado al límite de palabras");
      return false;
    }
    if (texto.length > this.puzzleMax) {
      alert("La palabra es muy larga");
      return false;
    }
    this.palabras.forEach((element) => {
      if (element.palabra == texto) {
        retorno = false;
        alert("¡La palabra ya existe!");
      }
    });
    return retorno;
  }
  /**********Random Horizontal */
  _horizontal(texto) {
    return new Promise((resolve) => {
      let tipo: number = 0;
      texto = texto.toLowerCase();
      let max = this.puzzleMin.y;

      let min = 0;
      let textlen = texto.length;
      let r = Math.floor(Math.random() * (max - 1 - 0 + 1) + min);

      let p = max - textlen;
      console.log("texto: " + texto);
      console.log("random: " + max);
      console.log("p: " + p);
      let pr = Math.floor(Math.random() * (p - 0 + 1) + min);
      console.log("pr: " + pr);
      let t = 0;
      let _this = this;
      let x = 0;
      let tf = 0;
      let insert = true;
      let coincidencia = 0;

      let bar = new Promise((resolve2, reject) => {
        this.puzzleObj.forEach((value, index, array) => {
          let casillas: any = value.idX;
          casillas.forEach((elementX) => {
            let clase = "r" + value.idY + "_c" + elementX;
            let elem: any = document.getElementById(clase) as HTMLInputElement;
            if (
              _this.pad(r, 2) == value.idY &&
              _this.pad(pr + x, 2) == elementX &&
              x < textlen
            ) {
              console.log("coincidencia: r" + value.idY + "_c" + elementX);
              console.log(
                "Caracter: " +
                  elem.innerText +
                  ", texto[" +
                  x +
                  "]: " +
                  texto[x]
              );
              if (elem.innerText && texto[x] != undefined) {
                if (elem.innerText != texto[x]) {
                  insert = false;
                }
              }
              x++;
            }
          });
          if (index === array.length - 1) {
            resolve2(insert);
          }
        });
      });
      let codigo = "";
      bar.then((insert) => {
        console.log("All done!", insert);
        if (insert) {
          for (let i = p; i < max; i++) {
            let clase = "#r" + _this.pad(r, 2) + "_c" + _this.pad(pr + t, 2);
            let duplic = 0;
            codigo += clase + ",";
            $(clase).text(texto[t]);
            t++;
            console.log("Clase: ", clase + " - " + p);
            if (i == max - 1) {
              codigo = codigo.replace(/,\s*$/, "");
              this.palabras.push({
                palabra: texto,
                codigo: codigo,
                tipo: this.posiciones[tipo],
              });
              this.palabraInput = "";
              console.log("palabras: ", this.palabras);
              console.log("this.puzzleIntentos: ", this.puzzleIntentos);
              this.puzzleIntentos = 0;
              if (this.palabras.length > 1) {
                this.paso3Active = true;
              } else {
                this.paso3Active = false;
              }
              resolve(true);
            }
          }
        } else {
          this.addText(texto).then((insert) => {
            resolve(false);
          });
          //this._horizontal(texto);
        }
      });
    });
  }
  _horizontalR(texto) {
    return new Promise((resolve) => {
      let res = true;
      let tipo: number = 1;
      texto = texto.toLowerCase();
      let max = this.puzzleMin.y;

      let min = 0;
      let textlen = texto.length;
      let fila = Math.floor(Math.random() * (max - 1 - 0 + 1) + min);
      let flen = max - textlen;
      let columna = Math.floor(Math.random() * (flen - 1 - 0 + 1) + min);
      let t = 0;
      let resultX = true;
      let _this = this;
      let x = 0;
      let tf = textlen - 1;
      let insert = true;
      let coincidencia = 0;
      tf = textlen - 1;
      let bar = new Promise((resolve2, reject) => {
        this.puzzleObj.forEach((value, index, array) => {
          let casillas: any = value.idX;
          x = 0;
          casillas.forEach(function (elementX) {
            if (value.idY == _this.pad(fila, 2)) {
              if (_this.pad(columna + x, 2) == elementX) {
                let id = "r" + value.idY + "_c" + elementX;
                console.log("id: " + texto[tf] + ": " + id);
                let elem: any = document.getElementById(id) as HTMLInputElement;
                x++;
                if (x >= textlen) {
                  x = 0;
                }
                try {
                  if (elem.innerText) {
                    console.log(
                      "id2: " + texto[tf] + ": " + id + ", tf: " + tf
                    );
                    if (tf >= 0) {
                      if (texto[tf] != elem.innerText) {
                        console.log(
                          "texto[tf]: " +
                            texto[tf] +
                            ", elem.innerText: " +
                            elem.innerText
                        );
                        resultX = false;
                      } else {
                        console.log(
                          "Igual: texto[tf]: " +
                            texto[tf] +
                            ", elem.innerText: " +
                            elem.innerText
                        );
                      }
                    }
                  } else {
                  }
                } catch (error) {}
                tf--;
              }
            }
          });
          if (index === array.length - 1) {
            resolve2(resultX);
          }
        });
      });

      let codigo = "";
      bar.then((insert) => {
        console.log("All done!", insert);
        if (insert) {
          let t = texto.length - 1;
          let x = 0;
          for (let i = 0; i < textlen; i++) {
            let clase =
              "#r" + _this.pad(fila, 2) + "_c" + _this.pad(columna + i, 2);
            let duplic = 0;
            codigo += clase + ",";
            $(clase).text(texto[t]);
            t--;

            //console.log('Clase: ',clase + ' - ' + i);
            if (i == texto.length - 1) {
              codigo = codigo.replace(/,\s*$/, "");
              this.palabras.push({
                palabra: texto,
                codigo: codigo,
                tipo: this.posiciones[tipo],
              });
              this.palabraInput = "";
              console.log("palabras: ", this.palabras);
              console.log("this.puzzleIntentos: ", this.puzzleIntentos);
              this.puzzleIntentos = 0;
              if (this.palabras.length > 1) {
                this.paso3Active = true;
              } else {
                this.paso3Active = false;
              }
              resolve(insert);
            }
          }
        } else {
          this.addText(texto).then((insert) => {
            resolve(false);
          });
          //this._horizontalR(texto);
        }
      });
    });
  }
  /**********Fin random Hirozontal */
  /**********Random Vertical */
  _vertical(texto) {
    console.log("Texto vertical: ", texto);
    return new Promise((resolve) => {
      let result = true;
      let tipo: number = 2;
      texto = texto.toLowerCase();
      let max = this.puzzleMin.y;
      let _this = this;
      let min = 0;
      let textlen = texto.length;
      let columna = Math.floor(Math.random() * (max - 1 - 0 + 1) + min);
      let vlen = max - textlen;

      let vertical = Math.floor(Math.random() * (vlen - 1 - 0 + 1) + min);
      console.log(
        "Vertical columna selected: " + columna + ", vertical: " + vertical
      );
      //console.log('columna: '+columna+', vertical: '+vertical);

      let resultX = true;
      let bar = new Promise((resolve2, reject) => {
        let v = 0;
        let t = 0;
        this.puzzleObj.forEach((value, index, array) => {
          let casillas: any = value.idX;
          casillas.forEach(function (elementX) {
            if (_this.pad(columna, 2) == elementX) {
              console.log(
                "Vertical elementX:" + elementX + ", value.idY:" + value.idY
              );
              if (_this.pad(vertical + v, 2) == value.idY) {
                console.log("Vertical value.idY:" + value.idY + "");
                console.log(
                  "vertical y: " +
                    value.idY +
                    ", columna: " +
                    _this.pad(columna, 2)
                );
                let id =
                  "r" + _this.pad(value.idY, 2) + "_c" + _this.pad(columna, 2);
                let elem: any = document.getElementById(id) as HTMLInputElement;
                if (elem.innerText) {
                  console.log(
                    "Vertical: if(" + elem.innerText + " == " + texto[v] + ")"
                  );
                  if (v < textlen) {
                    if (texto[v] != elem.innerText) {
                      console.log("False");
                      resultX = false;
                    } else {
                      ("True");
                    }
                  }
                  t++;
                } else {
                  t = 0;
                }
                v++;
              }
              //v++;
            }
          });
          if (index === array.length - 1) {
            resolve2(resultX);
          }
        });
      });
      let codigo = "";

      bar.then((insert) => {
        console.log("All done!", insert);
        if (insert) {
          let t = texto.length - 1;
          let x = 0;
          for (let i = vertical; i < max; i++) {
            //for (let i = vertical; i < (max); i++) {
            let clase = "#r" + _this.pad(i, 2) + "_c" + _this.pad(columna, 2);
            let duplic = 0;
            if (x < textlen) {
              codigo += clase + ",";
              $(clase).text(texto[x]);
            }

            x++;

            console.log("Clase: ", clase + " - " + i);
            if (i == max - 1) {
              codigo = codigo.replace(/,\s*$/, "");
              this.palabras.push({
                palabra: texto,
                codigo: codigo,
                tipo: this.posiciones[tipo],
              });
              this.palabraInput = "";
              console.log("palbras: ", this.palabras);
              console.log("this.puzzleIntentos: ", this.puzzleIntentos);
              this.puzzleIntentos = 0;
              if (this.palabras.length > 1) {
                this.paso3Active = true;
              } else {
                this.paso3Active = false;
              }
              resolve(result);
            }
          }
        } else {
          this.addText(texto).then((insert) => {
            resolve(false);
          });
          //this._horizontalR(texto);
        }
      });
    });
  }
  /**********Fin random Vertical */

  _verticalR(texto) {
    return new Promise((resolve) => {
      let result = true;
      let tipo: number = 3;
      texto = texto.toLowerCase();
      let max = this.puzzleMin.y;
      let _this = this;
      let min = 0;
      let textlen = texto.length;
      let columna = Math.floor(Math.random() * (max - 1 - 0 + 1) + min);
      let vlen = max - textlen;

      let vertical = Math.floor(Math.random() * (vlen - 1 - 0 + 1) + min);
      //console.log('Vertical columna selected: '+columna+', vertical: '+vertical);
      //console.log('columna: '+columna+', vertical: '+vertical);
      let resultX = true;
      let bar = new Promise((resolve2, reject) => {
        let v = 0;
        let t = textlen - 1;
        this.puzzleObj.forEach((value, index, array) => {
          let casillas: any = value.idX;
          casillas.forEach(function (elementX) {
            if (_this.pad(columna, 2) == elementX) {
              //console.log('VerticalR elementX:'+elementX+', value.idY:'+value.idY);
              if (_this.pad(vertical + v, 2) == value.idY) {
                console.log("VerticalR value.idY:" + value.idY + "");

                let id =
                  "r" + _this.pad(value.idY, 2) + "_c" + _this.pad(columna, 2);
                let elem: any = document.getElementById(id) as HTMLInputElement;
                if (elem.innerText) {
                  console.log(
                    "verticalR y: " +
                      value.idY +
                      ", columna: " +
                      _this.pad(columna, 2)
                  );
                  console.log(
                    "VerticalR: if(" + elem.innerText + " == " + texto[t] + ")"
                  );
                  if (t >= 0) {
                    if (texto[t] != elem.innerText) {
                      console.log("False");
                      resultX = false;
                    }
                  }
                } else {
                  //t=0;
                }
                t--;
                v++;
              }
              //v++;
            }
          });
          if (index === array.length - 1) {
            resolve2(resultX);
          }
        });
      });
      let codigo = "";

      bar.then((insert) => {
        console.log("All done!", insert);
        if (insert) {
          let t = texto.length - 1;
          let x = 0;
          for (let i = vertical; i < max; i++) {
            let clase = "#r" + _this.pad(i, 2) + "_c" + _this.pad(columna, 2);
            let duplic = 0;
            //codigo += clase+',';
            //$(clase).text(texto[t]);
            if (x < textlen) {
              codigo += clase + ",";
              $(clase).text(texto[x]);
            }
            x++;
            t--;
            console.log("Clase: ", clase + " - " + i);
            if (i == max - 1) {
              codigo = codigo.replace(/,\s*$/, "");
              this.palabras.push({
                palabra: texto,
                codigo: codigo,
                tipo: this.posiciones[tipo],
              });
              this.palabraInput = "";
              console.log("palbras: ", this.palabras);
              console.log("this.puzzleIntentos: ", this.puzzleIntentos);
              this.puzzleIntentos = 0;
              if (this.palabras.length > 1) {
                this.paso3Active = true;
              } else {
                this.paso3Active = false;
              }
              resolve(result);
            }
          }
        } else {
          this.addText(texto).then((insert) => {
            resolve(false);
          });
          //this._horizontalR(texto);
        }
      });
    });
  }
  /**********Fin random Vertical */
  /**************Diagonales***** _diagonalD */
  _diagonalD(texto) {
    return new Promise((resolve) => {
      texto = texto.toLowerCase();
      let tipo: number = 4;
      let max = this.puzzleMin.y;
      let _this = this;
      let min = 0;
      let textlen = texto.length;

      let textolen = max - textlen;

      let xy = Math.floor(Math.random() * (2 - 1 + 1) + min);
      let x = 0;
      let y = 0;
      let random1 = Math.floor(Math.random() * (textolen - 0 + 1) + min);
      let random2 = Math.floor(Math.random() * (textolen - 0 + 1) + min);
      if (xy == 0) {
        x = random1;
        y = random2;
      } else {
        y = random1;
        x = random2;
      }
      let next = 0;
      let result = true;

      let bar = new Promise((resolve2, reject) => {
        this.puzzleObj.forEach((value, index, array) => {
          let casillas: any = value.idX;
          casillas.forEach(function (elementX) {
            if (
              value.idY == _this.pad(y + next, 2) &&
              _this.pad(x + next, 2) == elementX
            ) {
              let id = "r" + value.idY + "_c" + elementX;
              console.log("_diagonalD id: " + id);
              let elem: any = document.getElementById(id) as HTMLInputElement;
              if (elem.innerText && texto[next] != undefined) {
                if (texto[next] != elem.innerText) {
                  result = false;
                }
              }
              next++;
            }
          });

          if (index === array.length - 1) {
            resolve2(result);
          }
        });
      });
      let codigo = "";
      bar.then((insert) => {
        if (insert) {
          let next = 0;
          for (let i = 0; i < textlen; i++) {
            let id =
              "#r" + _this.pad(y + next, 2) + "_c" + _this.pad(x + next, 2);
            $(id).text(texto[i]);
            next++;
            codigo += id + ",";
            if (i == textlen - 1) {
              codigo = codigo.replace(/,\s*$/, "");
              this.palabras.push({
                palabra: texto,
                codigo: codigo,
                tipo: this.posiciones[tipo],
              });
              this.palabraInput = "";
              console.log("palbras: ", this.palabras);
              console.log("this.puzzleIntentos: ", this.puzzleIntentos);
              this.puzzleIntentos = 0;
              if (this.palabras.length > 1) {
                this.paso3Active = true;
              } else {
                this.paso3Active = false;
              }
              resolve(insert);
            }
          }
        } else {
          this.addText(texto).then((insert) => {
            resolve(false);
          });
        }
      });
    });
  }
  /**************Fin Diagonales***** _diagonalD */
  pad(str, max) {
    str = str.toString();
    return str.length < max ? this.pad("0" + str, max) : str;
  }
  /****Fin Core Sopa de letras */
  validarPasos() {
    let input: any = document.getElementById("inputsP1") as HTMLInputElement;
    let expresion = input.pattern;
    let cadena = this.nombreActividad;
    let valid = cadena.match(expresion);
    let p: number = 1;
    if (valid) {
      p++;
      this.validP = p;
    } else {
      this.validP = p;
      input.setFocus();
      return;
    }
    let hab = 0;
    this.habilidad.forEach((element) => {
      if (element.seleccionado) {
        hab++;
      }
    });

    if (hab >= 2) {
      p++;
      this.validP = p;
    } else {
      return;
    }

    if (this.ejercicios.length > 0) {
      this.ejercicios.forEach((element, index, array) => {
        if (element.actividades.length > 0) {
          p++;
          this.validP = p;
        }
      });
    } else {
      return;
    }

    this.siPaso4(p);

    console.log("Paso activo: ", this.validP);
  }

  selectPaso(p = 1) {
    this.validarPasos();
    if (p <= this.validP) this.pasos = p;
  }

  next() {
    this.validarPasos();
    if (this.pasos < 5 && this.pasos < this.validP) {
      this.pasos++;
      console.log("pasos", this.pasos);
    }
  }

  prev() {
    if (this.pasos > 1) {
      this.pasos--;
    }
  }

  habilidadF(id) {
    let array: any = this.habilidad;
    let r: boolean = false;
    let count = 0;
    array.forEach((element) => {
      if (element.id == id) {
        element.seleccionado = !element.seleccionado;
      }
      if (element.seleccionado) {
        count++;
      }
    });
    if (count < 2) {
      this.validP = 2;
      this.pasos = this.validP;
    }
    this.validarPasos();
    return r;
  }

  btnHabilidades() {
    return this.actividadesHabilidades;
  }
  btnTipoEjercicios() {
    return this.actividadesEjercicios;
  }

  agregarEjercicio() {
    let id = 0;
    if (this.ejercicios.length > 0) {
      this.ejercicios.forEach((element) => {
        let temp_id = element.id;
        if (id < temp_id) {
          id = temp_id;
        }
      });
      id++;
    } else {
      id = 1;
    }
    let temp = { id: id, active: false, tipo: 0, actividades: [] };
    this.ejercicios.push(temp);
    this.siPaso4();
    this.validarPasos();
    this.selecEjer(id);
  }

  selecEjer(id) {
    console.log("🚀 ~ CrearActividadComponent ~ selecEjer ~ id:", id);
    this.paso3Active = false;
    if (this.ejercicios.length > 0) {
      this.ejercicios.forEach((element) => {
        if (element.id == id) {
          this.ejercicioActivo = element;
          element.active = true;
          this.ejercicioSelected = 1;
        } else {
          element.active = false;
        }
      });
      console.log("🚀 ~ selecEjer ~ this.ejercicios:", this.ejercicios);
    }
  }
  backP3() {
    this.ejercicioSelected = 0;
  }

  prev2() {
    this.prev();
  }
  next2() {
    this.next();
  }
  resetExercises() {
    // Opción múltiple
    this.opMultipleData = [];

    this.fvPregunta = "";
    this.fvFV = "";
    this.opcionExplicacion = "";
    // Completa el espacio
    this.textAreacomplateEspacio = "";
    this.explAreacomplateEspacio = "";
    // Ordenar principal
    this.ordenarArrayP = [
      { tipo: 1, input: "", recurso: { b64: null, file: null } },
    ];
    this.ordenarExplicacion = "";
    // Memoria
    this.selectedFiles = [];
    this.data_Memoria = [];
    this.memoriaArray = [];
    this.memoriaArrayObj = [];
    this.memObjFile = [];
    this.memObjItems = [];
    this.itemEditMem = null;
    // Sopa de letras
    this.palabras = [];
    this.data_SopaLetras = { tipo: 0, valor: null };
    this.puzzleMin = { y: 5, x: 5 };
    this.puzzleMax = 10;
    this.puzzleObj = [];
    // Clase de explicación
    this.claseExplicacion = "";
    this.explicaciontemaExpl = "";
    this.urlImage = null;
    this.fileImage = null;
    this.urlVideo = "";
    this.embedUrl = null;
    this.data_ClaseExplicacion = {
      tipo: 0,
      explicaciontema: "",
      explicaciontemaExp: "",
      recurso: { tipo: "", object: null },
    };
    // Pregunta abierta
    this.preguntaAbierta = "";
    this.id_preguntaA_file = 0;
    this.input_preguntaA_tipo = 0;
    this.recurso_pregunta_abierta = {
      tipo: "",
      value: "",
      object: null,
      b64: "",
    };
    this.data_preguntaAbierta = {
      tipo: 0,
      pregunta: "",
      recurso: { tipo: "", object: null },
    };
    // Ordenar secundario
    this.ordenarArrayS = [
      { tipo: 2, input: "", recurso: { b64: null, file: null } },
    ];
    this.ordenarExplicacion = "";
  }

  setDataExecice(data) {
    switch (data.id_tipo) {
      case 1:
        this.opMultipleData = data;
        break;
      case 2:
        this.fvPregunta = data.pregunta;
        this.fvFV = data.vf;
        this.opcionExplicacion = data.explicacion;
        break;
      case 3:
        this.textAreacomplateEspacio = data.valor;
        this.explAreacomplateEspacio = data.explicacion;
        break;
      case 4:
        this.ordenarArrayP = data.data;
        this.ordenarExplicacion = data.explicacion;
        this.validarOrdenarP();
        break;
      case 5:
        this.selectedFiles = data.files;
        this.createMoryData();
        break;
      case 6:
        this.palabras = data.valor;
        this.resizePuzle();
        break;
      case 7:
        this.claseExplicacion = data.explicaciontema;
        this.explicaciontemaExpl = data.explicaciontemaExpl;
        if (data.typeFile == 1) {
          this.urlImage = data.urlImage;
          this.fileImage = data.image;
          this.urlVideo = null;
          this.embedUrl = null;
        } else if (data.typeFile == 2) {
          this.urlImage = null;
          this.fileImage = null;
          this.urlVideo = data.link_video;
          this.embedVideo();
        }
        break;
      case 8:
        this.preguntaAbierta = data.pregunta;
        if (data.recurso.tipo == "img") {
          this.recurso_pregunta_abierta.tipo = data.recurso.tipo;
          this.recurso_pregunta_abierta.value = "";
          this.recurso_pregunta_abierta.object = data.recurso.object;
          this.recurso_pregunta_abierta.b64 = data.recurso.b64;
          this.id_preguntaA_file = 0;
          this.input_preguntaA_tipo = 0;
        } else if (data.recurso.tipo == "video") {
          this.recurso_pregunta_abierta.tipo = data.recurso.tipo;
          this.recurso_pregunta_abierta.value = data.recurso.url;
          this.recurso_pregunta_abierta.object = null;
          this.recurso_pregunta_abierta.b64 = "";
          this.id_preguntaA_file = 0;
          this.input_preguntaA_tipo = 0;
        }
        break;
      case 9:
        this.ordenarArrayS = data.data;
        this.ordenarExplicacion = data.explicacion;
        this.validarOrdenarS();
        break;
    }
  }
  addTipo(id) {
    this.resetExercises();
    console.log(
      "🚀 ~ CrearActividadComponent ~ addTipo ~ this.ejercicioActivo:",
      this.ejercicioActivo
    );
    if (
      this.ejercicioActivo &&
      this.ejercicioActivo.actividades.length > 0 &&
      this.ejercicioActivo.actividades[0]?.id_tipo == id
    ) {
      this.setDataExecice(this.ejercicioActivo.actividades[0]);
    }
    this.select_tipo_ejercicio = id;
    if (this.ejercicios.length > 0) {
      this.ejercicios.forEach((element) => {
        if (element.active) {
          //element.tipo = id;
          if (id == 4) {
            this.AcOrdenarTipo = 1;
          }
          if (id == 9) {
            this.AcOrdenarTipo = 2;
          }
          if (id == 6) {
            this.resizePuzle();
          }
          return;
        } else {
          //element.active = false;
        }
      });
    }
  }

  cancelTipoEjercicio() {
    this.select_tipo_ejercicio = 0;
  }

  /********Sección de actividades*************** */

  /********* */

  /********Fin Sección de actividades*********** */

  initControl() {
    this.countopcion++;
    return this.formBuilder.control({
      id: [this.countopcion, [Validators.required, Validators.minLength(1)]],
      respuesta: [
        "",
        [
          Validators.required,
          Validators.pattern("[0-9A-Za-zá-ÿÁ-ÿ .,¿?!¡]{1,100}"),
        ],
      ],
      verdadero: [false, [Validators.required]],
    });
  }

  addOpcion() {
    this.id_pos++;

    this["opciones"].push({
      id: this.id_pos,
      respuesta: "",
      verdadero: false,
    });
  }
  deleteOption(id) {
    if (this.opciones.length > 1)
      this.opciones.forEach((element, i) => {
        if (element.id == id) {
          this.opciones.splice(i, 1);
        }
      });
  }

  removeFileOpQ() {
    this.data_option_tipoQ.tipo = "";
    this.data_option_tipoQ.value = "";
    this.data_option_tipoQ.object = null;
    this.data_option_tipoQ.b64 = "";
    this.id_option_fileQ = 0;
  }
  uploadFileOpQ(event: EventTarget) {
    let eventObj: any = event;
    let target: HTMLInputElement = eventObj.target as HTMLInputElement;
    let files = target.files;
    let file: File = target.files[0];
    let _this = this;
    let id = this.id_option_file;
    if (FileReader && file && files.length) {
      var fr = new FileReader();
      fr.onload = function () {
        //{tipo:'',value:'',object:null,b64:''};
        let b64 = fr.result;
        _this.data_option_tipoQ.tipo = "img";
        _this.data_option_tipoQ.value = "";
        _this.data_option_tipoQ.object = file;
        _this.data_option_tipoQ.b64 = b64;
        _this.id_option_fileQ = 0;
      };
      fr.readAsDataURL(file);
      //this.closeFileAdd();
    }
  }

  closeFileAdd() {
    this.id_option_file = 0;
    this.input_option_tipo = 0;
    let inputBox: any = document.getElementById("file-content");
    inputBox.style.display = "none";
  }
  //id_option_file
  //link_option_y
  //input_option_tipo
  btnVideoFile() {
    this.input_option_tipo = 1;
  }
  btnImgFile() {
    this.input_option_tipo = 2;
  }
  addFileOpPregunta() {
    this.id_option_fileQ = 1;
    //input_option_tipoQ:number = 0;
  }
  closeFileOpPregunta() {
    this.id_option_fileQ = 0;
    this.input_option_tipoQ = 0;
    this.input_option_Q = "";
  }
  saveFileOpPregunta() {
    //data_option_tipoQ
    //{tipo:'',value:'',object:null,b64:''};
    //input-question-y
    if (this.input_option_tipoQ == 1) {
    } else if (this.input_option_tipoQ == 2) {
      let input: any = document.getElementById(
        "input-question-y"
      ) as HTMLInputElement;
      let expresion = input.pattern;
      let cadena = input.value;
      let valid = cadena.match(expresion);
      if (!valid) {
        input.setFocus();
        return;
      }
      let value = this.input_option_Q;
      this.data_option_tipoQ.tipo = "video";
      this.data_option_tipoQ.value = value;
      this.data_option_tipoQ.object = null;
      this.data_option_tipoQ.b64 = "";
      console.log("this.data_option_tipoQ: ", this.data_option_tipoQ);
      this.input_option_tipoQ = 0;
      this.id_option_fileQ = 0;
    }
  }
  btnImgFileQ() {
    this.input_option_tipoQ = 1;
  }
  btnVideoFileQ() {
    this.input_option_tipoQ = 2;
  }
  addFileOp(id, i, el) {
    if (this.id_option_file > 0) {
      if (this.id_option_file != id) {
        return;
      }
      this.closeFileAdd();
      return;
    }

    this.id_option_file = id;
    let input: any = document.getElementById(el);
    var rec = input.offsetHeight;
    let inputBox: any = document.getElementById("file-content");
    inputBox.style.top = rec * i + 52 + "px";
    inputBox.style.display = "block";
    console.log("ID: ", id);
    console.log("rec.top: ", rec);
  }

  /*****CORE VERDADERO/FALSO******** */
  setVF(vf) {
    //this.verificarVF();
    this.fvFV = vf;
    let temp = { pregunta: null, vf: vf, explicacion: null };
    this.updateStringSubject();
  }
  validInput(input, focus = false) {
    const isTextarea = input.tagName?.toLowerCase() === "textarea";
    const cadena = input.value;
    const expresion = !isTextarea ? input.pattern : null;

    // Validar si existe texto
    if (cadena) {
      if (isTextarea) {
        // Validamos solo la longitud si es textarea
        if (cadena.length <= this.maxLengthTextArea) {
          return true;
        }
      } else {
        // Si hay patrón, lo validamos
        if (!expresion || cadena.match(expresion)?.[0] === cadena) {
          return true;
        }
      }

      // Si no pasó la validación
      if (focus) input.setFocus?.();
      return false;
    } else {
      // Si el campo está vacío, solo pasa si no es requerido
      if (!input.required) {
        return true;
      } else {
        if (focus) input.setFocus?.();
        return false;
      }
    }
  }

  verificarVF(toastM = true, focus = true) {
    let valid = 0;
    // //vfExpl
    // let inputExp: any = document.getElementById("vfExpl") as HTMLInputElement;
    // if (!this.validInput(inputExp, focus)) {
    //   valid++;
    // }
    let inputPreg: any = document.getElementById(
      "vfPregunta"
    ) as HTMLInputElement;
    if (!this.validInput(inputPreg, focus)) {
      valid++;
    }
    let vf = this.fvFV;
    if (vf == "") {
      valid++;
      if (toastM)
        this.toastController
          .create({
            message: "Seleccione Verdadero o Falso",
            duration: 2000,
          })
          .then((toast) => toast.present());
    }
    if (valid == 0) {
      return true;
    } else {
      return false;
    }
  }
  guardarVerdaderoFalso() {
    //vfPregunta
    let inpuPreg: any = document.getElementById(
      "vfPregunta"
    ) as HTMLInputElement;
    if (!this.validInput(inpuPreg, true)) {
      return;
    }
    //vfExpl
    let inputExp: any = document.getElementById("vfExpl") as HTMLInputElement;
    if (!this.validInput(inputExp, true)) {
      return;
    }
    let pregunta = this.fvPregunta;
    let ejercicio = this.ejercicioActivo.id;
    let vf = this.fvFV;
    let explicacion = inputExp.value;
    let select_tipo_ejercicio = this.select_tipo_ejercicio;
    let objTemp = {
      ej: ejercicio,
      tipo: select_tipo_ejercicio,
      pregunta: pregunta,
      vf: vf,
      explicacion: explicacion,
    };
    this.dataVF.push(objTemp);
    this.vfLimpiarForm();
  }
  vfLimpiarForm() {
    this.opcionExplicacion = "";
    this.fvPregunta = "";
    this.fvFV = "";
  }
  /***********FIN CORE VERDADERO/FALSO*********************** */
  ngOnDestroy() {
    this.dragulaService.destroy("bag");
    this.subscription.unsubscribe();
    this.actividadesEjercicios = [];
    this.actividadesHabilidades = [];
  }

  public subscription = this.stringVar$.subscribe((data) => {
    // do stuff with data
    // e.g. this.property = data
    if (data.valid) {
      this.paso3Active = true;
    } else {
      this.paso3Active = false;
    }
  });
  public updateStringSubject() {
    let actual: any = this.stringVar.asObservable();
    let temp: any = actual.source._value;
    temp.valid = this.verificarVF(false, false);
    this.stringVar.next(temp);
  }
  vfVerificar() {
    this.updateStringSubject();
  }
  /********Core Completa el espacio****** */
  completaespacioGuardar() {
    this.textAreaVerific();
    //dataAreacomplateEspacio
    let tipoejercicio = this.ejercicioSelected;
    this.dataAreacomplateEspacio.tipo = tipoejercicio;
    let valor = this.textAreacomplateEspacio;
    this.dataAreacomplateEspacio.valor = valor;
    let explicacon = this.explAreacomplateEspacio;
    let temp = this.dataAreacomplateEspacio;
    let new_temp = { id_tipo: this.select_tipo_ejercicio };
    let merged = Object.assign(new_temp, temp);
    temp = merged;

    this.ejercicios.forEach((element) => {
      if (element.active) {
        temp.tipo = element.tipo;
        temp.explicacion = explicacon;
        element.actividades = [temp];
        element.tipo = this.select_tipo_ejercicio;
        this.siPaso4();
        this.validarPasos();
      }
    });
    this.dataAreacomplateEspacio = [];
    this.respuestasAreacomplateEspacio = [];
    this.ejercicioSelected = 0;
    this.select_tipo_ejercicio = 0;
    this.textAreacomplateEspacio = "";
    this.explAreacomplateEspacio = "";
  }
  textAreaVerific() {
    console.log("textAreacomplateEspacio: ", this.textAreacomplateEspacio);
    let inputArea: any = document.getElementById(
      "completa-area-id"
    ) as HTMLInputElement;
    let expresion = inputArea.pattern;
    let cadena = inputArea.value;
    let valid = cadena.match(expresion);
    let error = 0;
    //explAreacomplateEspacio
    let inpuCompAreaExpl: any = document.getElementById(
      "completa-espacio-expl"
    ) as HTMLInputElement;
    let expresion2 = inpuCompAreaExpl.pattern;
    let cadena2 = inpuCompAreaExpl.value;
    let valid2 = cadena2.match(expresion2);
    if (!valid) {
      error++;
    }
    if (cadena2)
      if (!valid2) {
        error++;
      }
    //completa-area-id
    let tesst = this.textAreacomplateEspacio;
    let test: any = tesst.match(/\[([^\[]*)\]/g);
    if (test != null) {
      for (let i = 0; i < test.length; i++) {
        test[i] = test[i].replace(/\[/g, "");
        test[i] = test[i].replace(/\]/g, "");
      }
      this.respuestasAreacomplateEspacio = test;
    } else {
      this.respuestasAreacomplateEspacio = [];
    }
    if (this.respuestasAreacomplateEspacio.length > 0 && error == 0) {
      this.paso3Active = true;
    } else {
      this.paso3Active = false;
    }
    console.log("test: ", this.respuestasAreacomplateEspacio);
  }
  /********************** */
  /********Core Pregunta abierta****** */
  preguntaAbiertaVerificar() {
    let inputText: any = document.getElementById(
      "preguntaAbierta-id"
    ) as HTMLInputElement;
    if (this.validInput(inputText, true)) {
      this.paso3Active = true;
    } else {
      this.paso3Active = false;
    }
  }
  savePreguntaAbieta() {
    //data_preguntaAbierta:any = {tipo:0,pregunta:'',recurso:{tipo:'',object:null}};
    let inputText: any = document.getElementById(
      "preguntaAbierta-id"
    ) as HTMLInputElement;
    if (this.validInput(inputText, true)) {
      this.data_preguntaAbierta.pregunta = this.preguntaAbierta;
      this.data_preguntaAbierta.recurso.tipo =
        this.recurso_pregunta_abierta.tipo;
      if (this.recurso_pregunta_abierta.tipo == "video") {
        this.data_preguntaAbierta.recurso.object =
          this.recurso_pregunta_abierta.value;
      } else if (this.recurso_pregunta_abierta.tipo == "img") {
        this.data_preguntaAbierta.recurso.object =
          this.recurso_pregunta_abierta.object;
        this.data_preguntaAbierta.recurso.b64 =
          this.recurso_pregunta_abierta.b64;
      }
      let temp = this.data_preguntaAbierta;

      //console.log("temp: ",temp);
      let new_temp = { id_tipo: this.select_tipo_ejercicio };
      let merged = Object.assign(new_temp, temp);
      temp = merged;
      //console.log("merged: ",temp);

      this.ejercicios.forEach((element) => {
        if (element.active) {
          temp.tipo = element.tipo;
          element.actividades = [temp];
          element.tipo = this.select_tipo_ejercicio;
          this.siPaso4();
          this.validarPasos();
        }
      });
      this.data_preguntaAbierta = {
        tipo: 0,
        pregunta: "",
        recurso: { tipo: "", object: null },
      };
      this.recurso_pregunta_abierta = {
        tipo: "",
        value: "",
        object: null,
        b64: "",
      };
      this.ejercicioSelected = 0;
      this.select_tipo_ejercicio = 0;
      this.id_preguntaA_file = 0;
      this.input_preguntaA_tipo = 0;
      this.paso3Active = false;
    }
    this.preguntaAbierta = "";
    console.log("ejercicios: ", this.ejercicios);
  }
  addFilePreguntaAbierta() {
    this.id_preguntaA_file = 1;
  }
  btnImgFilePA() {
    this.input_preguntaA_tipo = 1;
  }
  btnVideoFilePA() {
    this.input_preguntaA_tipo = 2;
  }
  removeFilePA() {
    this.recurso_pregunta_abierta.tipo = "";
    this.recurso_pregunta_abierta.value = "";
    this.recurso_pregunta_abierta.object = null;
    this.recurso_pregunta_abierta.b64 = "";
  }

  closeFilePreguntaA() {
    this.id_preguntaA_file = 0;
    this.input_preguntaA_tipo = 0;
  }
  async uploadFileOrUrlPA(ev: Event) {
    const popover = await this.popoverCtrl.create({
      component: ModalLoadFilesComponent,
      event: ev,
      translucent: true,
      showBackdrop: true,
      cssClass: "custom-files-popover",
    });

    await popover.present();
    const { data } = await popover.onDidDismiss();
    if (data) {
      if (data.type == 1) {
        this.recurso_pregunta_abierta.tipo = "img";
        this.recurso_pregunta_abierta.value = "";
        this.recurso_pregunta_abierta.object = data.file;
        this.recurso_pregunta_abierta.b64 = data.url;
        this.id_preguntaA_file = 0;
        this.input_preguntaA_tipo = 0;
      } else if (data.type == 2) {
        this.recurso_pregunta_abierta.tipo = "video";
        this.recurso_pregunta_abierta.value = data.url;
        this.recurso_pregunta_abierta.object = null;
        this.recurso_pregunta_abierta.b64 = "";
        this.id_preguntaA_file = 0;
        this.input_preguntaA_tipo = 0;
      }
    }
  }
  /********Fin Core Pregunta abierta****** */

  /********Core Clase de explicación****** */
  claseExplicacionVerificar() {
    let inputText: any = document.getElementById(
      "claseExplicacion-id"
    ) as HTMLInputElement;
    if (this.validInput(inputText, true)) {
      this.paso3Active = true;
      // if (this.embedUrl || this.urlImage) {
      //   this.paso3Active = true;
      // } else {
      //   this.paso3Active = false;
      // }
    } else {
      this.paso3Active = false;
    }
  }

  embedVideo() {
    const youtubeRegex =
      /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    if (youtubeRegex.test(this.urlVideo)) {
      const videoId = this.urlVideo.match(youtubeRegex)[1];
      this.embedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        `https://www.youtube.com/embed/${videoId}`
      );
    } else {
      this.embedUrl = null;
      alert("Invalid URL");
    }
  }
  claseExplicacionVerificarExp() {
    let inputText: any = document.getElementById(
      "claseExplicacionExp-id"
    ) as HTMLInputElement;
    if (this.validInput(inputText, true)) {
      if (this.urlVideo) {
        this.paso3Active = true;
      } else {
        this.paso3Active = false;
      }
    } else {
      this.paso3Active = false;
    }
  }
  addFileClaseExplicacion() {
    let inputText: any = document.getElementById(
      "video-input"
    ) as HTMLInputElement;
    inputText.click();
  }

  b64toBlob(b64Data, contentType) {
    contentType = contentType || "";
    var sliceSize = 512;
    var byteCharacters = atob(b64Data);
    var byteArrays = [];
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);
      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  btnImgFileCE() {}
  btnVideoFileCE() {}
  saveFileClaseE() {}
  uploadFileCE(event) {}
  closeFileClaseE() {}
  saveOrdenar() {
    let new_temp = { id_tipo: this.select_tipo_ejercicio };
    // Verifica si el tipo de ejercicio es 1 o 2
    if (this.AcOrdenarTipo == 1) {
      let AcOrdenarTipo = this.AcOrdenarTipo;
      let explicacion = this.ordenarExplicacion;

      // Crear una copia independiente del objeto
      let temp = {
        ...new_temp,
        tipo: AcOrdenarTipo,
        explicacion: explicacion,
        data: [...this.ordenarArrayP], // Crea una copia de ordenarArrayP
      };

      this.ejercicios.forEach((element) => {
        if (element.active) {
          element.actividades = [temp]; // Agregar la copia
          element.tipo = this.select_tipo_ejercicio;
          this.siPaso4();
          this.validarPasos();
          this.resetOrdenar();
        }
      });
      this.AcOrdenarTipo = 1;
      this.ejercicioSelected = 0;
      this.ordenarExplicacion = "";
      this.select_tipo_ejercicio = 0;
      console.log("this.ejercicios: ", this.ejercicios);
    } else if (this.AcOrdenarTipo == 2) {
      let AcOrdenarTipo = this.AcOrdenarTipo;
      let explicacion = this.ordenarExplicacion;

      // Crear una copia independiente del objeto
      let temp = {
        ...new_temp,
        tipo: AcOrdenarTipo,
        explicacion: explicacion,
        data: [...this.ordenarArrayS], // Crea una copia de ordenarArrayS
      };

      this.ejercicios.forEach((element) => {
        if (element.active) {
          element.actividades = [temp]; // Agregar la copia
          element.tipo = this.select_tipo_ejercicio;
          this.resetOrdenar();
        }
      });
      this.AcOrdenarTipo = 1;
      this.ejercicioSelected = 0;
      this.ordenarExplicacion = "";
      this.select_tipo_ejercicio = 0;
      console.log("this.ejercicios: ", this.ejercicios);
    }
  }

  saveMemoria() {
    this.data_Memoria = [
      { tipo: this.ejercicioSelected, data: this.memoriaArrayObj },
    ];
    let temp = this.data_Memoria;
    console.log("temp: ", temp);
    let new_temp = {
      id_tipo: this.select_tipo_ejercicio,
      files: this.selectedFiles,
    };
    let merged = Object.assign(new_temp, temp);
    temp = merged;
    this.ejercicios.forEach((element) => {
      if (element.active) {
        temp.tipo = element.tipo;
        element.actividades = [temp];
        element.tipo = this.select_tipo_ejercicio;
        this.siPaso4();
        this.validarPasos();
        this.resetMemoria();
      }
    });
    this.ejercicioSelected = 0;
    this.select_tipo_ejercicio = 0;
    this.paso3Active = false;
    this.selectedFiles = [];
    console.log("ejercicios: ", this.ejercicios);
  }
  /**************** */
  saveSopaLetras() {
    //data_SopaLetras = {tipo:0,valor:null};
    this.data_SopaLetras.tipo = this.ejercicioSelected = 0;
    this.data_SopaLetras.valor = this.palabras;

    let temp = this.data_SopaLetras;

    //console.log("temp: ",temp);
    let new_temp = { id_tipo: this.select_tipo_ejercicio };
    let merged = Object.assign(new_temp, temp);
    temp = merged;

    this.ejercicios.forEach((element) => {
      if (element.active) {
        temp.tipo = element.tipo;
        element.actividades = [temp];
        element.tipo = this.select_tipo_ejercicio;
        this.siPaso4();
        this.validarPasos();
      }
    });
    this.data_SopaLetras = { tipo: 0, valor: null };
    this.palabras = [];
    this.ejercicioSelected = 0;
    this.select_tipo_ejercicio = 0;
    this.paso3Active = false;
  }
  saveClaseExplicacion() {
    //claseExplicacionExp
    this.data_ClaseExplicacion.explicaciontemaExpl = this.explicaciontemaExpl;
    this.data_ClaseExplicacion.explicaciontema = this.claseExplicacion;
    this.data_ClaseExplicacion.link_video = this.urlVideo;
    this.data_ClaseExplicacion.image = this.fileImage;
    this.data_ClaseExplicacion.urlImage = this.urlImage;
    this.data_ClaseExplicacion.typeFile = this.typeFile;
    let temp = this.data_ClaseExplicacion;

    //console.log("temp: ",temp);
    let new_temp = { id_tipo: this.select_tipo_ejercicio };
    let merged = Object.assign(new_temp, temp);
    temp = merged;
    //console.log("merged: ",temp);

    this.ejercicios.forEach((element) => {
      if (element.active) {
        temp.tipo = element.tipo;
        element.actividades = [temp];
        element.tipo = this.select_tipo_ejercicio;

        this.data_ClaseExplicacion = {
          tipo: 0,
          explicaciontema: "",
          explicaciontemaExp: "",
        };
        this.resetClaseExplicacion();
        this.siPaso4();
        this.validarPasos();
      }
    });
    this.paso3Active = false;
  }

  resetClaseExplicacion() {
    this.claseExplicacion = "";
    this.urlVideo = "";
    this.embedUrl = null;
    this.fileImage = null;
    this.urlImage = "";
    this.explicaciontemaExpl = "";
    this.ejercicioSelected = 0;
    this.select_tipo_ejercicio = 0;
    this.id_claseExplicacion_file = 0;
    this.input_claseE_tipo = 0;
  }
  /********Fin Core Clase de explicación****** */
  validarOpMultiInput(input) {
    let expresion = input.pattern;
  }
  /**Opción 1:  Opción múltiple */
  opMultiples() {
    return {
      data: {
        pregunta: "",
        recurso: {
          valor: "",
          tipo: "", //link,imagen
        },
        explicacion: "",
        opciones: [
          {
            id: 0,
            respuesta: "",
            verdadero: false,
            recurso: {
              valor: "",
              tipo: "", //link,imagen
            },
          },
        ],
      },
    };
  }

  siPaso4(p = 0) {
    let total = this.ejercicios.length;
    let finalizados = 0;
    let result: boolean = false;
    console.log("siPaso4()...");
    if (this.ejercicios.length > 0) {
      this.ejercicios.forEach((element, index, array) => {
        // if (element.actividades.length > 0) {
        //   finalizados++;
        // }
        if (this.isActIndivi !== 2) {
          finalizados++;
        }
        if (index == array.length - 1) {
          console.log("total: ", total);
          console.log("finalizados: ", finalizados);

          if (finalizados == total) {
            if (p >= 4) {
              this.validP = 5;
            }
            console.log("Paso 4 activo: ", this.validP);
            result = true;
          } else {
            result = false;
          }
          return result;
        }
      });
    } else {
      return result;
    }
  }

  finalizarP3() {
    switch (this.select_tipo_ejercicio) {
      case 1:
        this.saveMultiOpt();
        break;
      case 2:
        this.saveFV();
        break;
      case 3:
        this.completaespacioGuardar();
        break;
      case 4:
        this.saveOrdenar();
        break;
      case 5:
        this.saveMemoria();
        break;
      case 6:
        this.saveSopaLetras();
        break;
      case 7:
        this.saveClaseExplicacion();
        break;
      case 8:
        this.savePreguntaAbieta();
        break;
      case 9:
        this.saveOrdenar();
        break;
      //
    }
  }
  saveMultiOpt() {
    this.ejercicios.forEach((element) => {
      if (element.active) {
        element.actividades = [this.opMultipleData];
        element.tipo = this.select_tipo_ejercicio;
        this.siPaso4();
        this.validarPasos();
      }
    });
    this.countopcion = 0;
    this.ejercicioSelected = 0;
    this.select_tipo_ejercicio = 0;
    this.opMultipleData = [];
  }

  saveFV() {
    this.select_tipo_ejercicio;
    let temp = {
      tipo: this.ejercicioActivo.id,
      pregunta: this.fvPregunta,
      vf: this.fvFV,
      explicacion: this.opcionExplicacion,
      id_tipo: this.select_tipo_ejercicio,
    };
    this.ejercicios.forEach((element) => {
      if (element.active) {
        element.actividades = [temp];
        element.tipo = this.select_tipo_ejercicio;
        this.siPaso4();
        this.validarPasos();
      }
    });
    this.dataVF.push(temp);
    this.vfLimpiarForm();
    this.ejercicioSelected = 0;
    this.select_tipo_ejercicio = 0;
  }

  async presentAlert() {
    const alert = await this.alertController.create({
      header: "Alerta",
      message: "Por favor, selecciona una opción de si o no en Fecha.",
      buttons: ["OK"],
    });

    await alert.present();
  }

  finalizarActividad() {
    //actividadesEjercicios:any = [];
    //actividadesHabilidades:any = [];
    this.reload = true;
    let habilidades: any = [];
    let libros: any = [];
    this.actividadesHabilidades.forEach((element, index, array) => {
      if (element.seleccionado) {
        habilidades.push({
          id: element.id,
          index: element.index,
          valor: element.valor,
        });
      }
      if (index == array.length - 1) {
        if (this.isFechaHoraEntrega === undefined) {
          this.presentAlert();
          return;
        }

        let fecha = "";
        let fecha_end = "";
        if (this.isFechaHoraEntrega == "1") {
          (fecha = this.datePipe.transform(
            this.fecha.start,
            "yyyy-MM-dd H:mm"
          )),
            (fecha_end = this.datePipe.transform(
              this.fecha.end,
              "yyyy-MM-dd H:mm"
            ));
        }
        let tempData = {
          id_user: this.id_user,
          nombre_actividad: this.nombreActividad,
          habilidades: habilidades,
          fecha: fecha,
          fecha_fin: fecha_end,
          ejercicios: this.ejercicios,
          libros: libros,
          id_curso: this.curso.id,
          estudiantes: this.id_user_actv,
          actvidades: 0,
        };
        this.showLoader();
        this.ejerciciosData = [tempData];
        this.actividadesService
          .saveActividad(this.auth_key, this.ejerciciosData)
          .subscribe(
            (response) => {
              console.log("Data: ", response);
              let result: any = response;
              let message = "";
              if (result.error == 0) {
                this.resetALL();
                message = "Se ha creado la actividad";
              } else {
                console.log("result", result);
                if (!result.auth_key) {
                  this.authService.logout();
                } else {
                  this.reload = false;
                  message = "Ocurrió un error, inténtelo más tarde";
                }
              }
              this.hideLoader();
              this.saveAllMsg(message);
              if (result.error == 0) {
                this.dataService.itemSelectedMenu.next(1);
              }
              //window.location.reload();
            },
            (error) => {
              this.hideLoader();
              console.log("Error: ", error);
            }
          );
      }
    });
  }

  getDateActi() {
    this.fecha.start = new Date(this.fecha.start).toISOString();
  }

  getDateActiEnd() {
    console.log("Fecha end: ", this.fecha);
  }

  generateUUID() {
    return UUID.UUID();
  }

  follow(idSigue) {
    this.loadingServices.present("Por favor esper...");
    this.searchService
      .follow(this.id, this.auth_key, idSigue)
      .subscribe((res) => {
        if (res.follow) {
          document.getElementById(`btn${idSigue}`).innerHTML =
            "Dejar de seguir";
          document.getElementById(`btn${idSigue}`).style.color =
            "#2dd36f !important";
          // this.following = true;
        }
        if (res.unfollow) {
          document.getElementById(`btn${idSigue}`).innerHTML = "Seguir";
          document.getElementById(`btn${idSigue}`).style.color =
            "#f4f5f8 !important";
          // this.following = true;
        }
        this.loadingServices.dismiss();
      });
  }

  serchText() {
    this.searchService.event.emit(this.textSearch);
    if (this.textSearch != "") {
      this.navCtrl.navigateRoot("/search");
    }
  }

  onSearchInput() {
    this.getStudents();
  }

  selectPerson(id) {
    const index = this.id_user_actv.indexOf(id);
    if (index > -1) {
      this.id_user_actv.splice(index, 1);
    } else {
      this.id_user_actv.push(id);
    }
    this.siPaso4();
    this.validarPasos();
  }

  getStudents() {
    this.cursosService
      .getEstudiantesCurso(
        this.id_user,
        this.auth_key,
        this.curso.id,
        this.textSearch
      )
      .subscribe(
        (student: any) => {
          console.log("Students course", student);
          if (student) {
            this.searchPersonsResult = student.result;
            console.log("student", student);
          } else {
            console.log(
              "No se recibieron datos de calificaciones de los estudiantes al profesor."
            );
          }
        },
        (error) => {
          console.error("Error al obtener datos de calificaciones:", error);
        }
      );
  }

  fileValidator(control: any) {
    if (!control.value || control.value.length === 0) {
      return { required: true };
    }

    if (control.value.length < 2) {
      return { minFiles: true };
    }

    if (control.value.length > 20) {
      return { maxFiles: true };
    }

    return null;
  }

  onFileChange(event: any) {
    const files: FileList = event.target.files;
    const validImageTypes = [
      "image/gif",
      "image/jpeg",
      "image/png",
      "image/svg+xml",
      "image/webp",
    ];

    // Reset error message and selected files
    this.errorMessage = "";

    // Check the number of files
    var countFiles = this.selectedFiles.length + files.length;
    console.log("countFiles: ", countFiles);
    if (countFiles < 2) {
      this.errorMessage = "Debes seleccionar al menos 2 imágenes.";
      return;
    }

    if (countFiles > 18) {
      this.errorMessage = "No puedes seleccionar más de 18 imágenes.";
      return;
    }

    // Validate each file type
    for (let i = 0; i < files.length; i++) {
      if (!validImageTypes.includes(files[i].type)) {
        this.errorMessage =
          "Solo puedes seleccionar archivos de imagen (jpg, jpeg, png, gif, svg, webp).";
        return;
      }
      this.selectedFiles.push(files[i]);
    }
    this.createMoryData();
  }

  createMoryData() {
    // Update form control value
    this.form.patchValue({
      images: this.selectedFiles,
    });

    this.form.get("images")?.updateValueAndValidity();
    if (this.form.valid) {
      this.memoriaInit();
    }
  }

  onSubmit() {
    if (this.form.valid) {
      // Handle form submission
      console.log("Form submitted:", this.selectedFiles);
    } else {
      this.errorMessage = "Por favor, selecciona entre 2 y 20 imágenes.";
    }
  }

  deletePalabra(index) {
    this.palabras.splice(index, 1);
    this.resizePuzle();
  }

  async handleFileOrUrlChange(ev: Event) {
    const popover = await this.popoverCtrl.create({
      component: ModalLoadFilesComponent,
      event: ev,
      translucent: true,
      showBackdrop: true,
      cssClass: "custom-files-popover",
    });

    await popover.present();
    const { data } = await popover.onDidDismiss();
    if (data) {
      this.typeFile = data.type;
      if (data.type == 1) {
        this.urlImage = data.url;
        this.fileImage = data.file;
        this.urlVideo = null;
        this.embedUrl = null;
      } else if (data.type == 2) {
        this.urlImage = null;
        this.fileImage = null;
        this.urlVideo = data.url;
        this.embedVideo();
      }
    }
    this.claseExplicacionVerificar();
  }

  showLoader() {
    this.loadingCtrl
      .create({
        message: "Procesando...",
      })
      .then((res) => {
        res.present();
        res.onDidDismiss().then((dis) => {});
      });
  }

  hideLoader() {
    setTimeout(() => {
      this.loadingCtrl.dismiss();
    }, 200);
  }

  getNameEjercicio(id) {
    let name = "";
    this.tipo_ejercicios.forEach((element) => {
      if (element.id == id) {
        name = element.titulo;
      }
      if (id == 9) {
        name = "Secuencia";
      }
    });
    return name;
  }
}
